"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledPopover = exports.StyledTargetWrapper = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n      opacity: 1;\n      pointer-events: auto;\n    "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n      opacity: 0;\n      pointer-events: auto;\n    "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  box-shadow: 0 0 16px 0 rgba(0, 0, 0, 0.05);\n  opacity: 0;\n  transition: opacity ", "ms\n    cubic-bezier(0.4, 0, 0.2, 1);\n  z-index: 2000;\n  pointer-events: none;\n\n  &[data-x-out-of-boundaries] {\n    display: none;\n  }\n\n  ", ";\n\n  ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: inline-block;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledTargetWrapper = _styledComponents.default.div(_templateObject());

exports.StyledTargetWrapper = StyledTargetWrapper;

var StyledPopover = _styledComponents.default.div(_templateObject2(), function (props) {
  return props.transitionDuration;
}, function (props) {
  return props.transitionState === 'entering' && (0, _styledComponents.css)(_templateObject3());
}, function (props) {
  return props.transitionState === 'entered' && (0, _styledComponents.css)(_templateObject4());
});

exports.StyledPopover = StyledPopover;


//////////////////
// WEBPACK FOOTER
// ./node_modules/calcite-react/Popover/Popover-styled.js
// module id = 1571
// module chunks = 0